import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MeliServices } from 'src/app/services/meli.service';


@Component({
    selector: 'item-meli-catalogo-card',
    templateUrl: './item-meli-catalogo-card.component.html',
    styleUrls: ['./item-meli-catalogo-card.component.scss'],
    standalone: false
})
export class ItemMeliCatalogoCardComponent implements OnInit {

  constructor(private meliServices:MeliServices) { }
  @Input('data') data:Object;
  @Input('codeCompany') codeCompany;
  attribIndex=1;
  @Output() submitted: EventEmitter<Object> = new EventEmitter(); 
  @Input('product_identifier') product_identifier:string
  ngOnInit(): void {
  }

  select(data){
    this.submitted.emit(data);
  }

  getBuyBox(data){
      let id = data['id'];
      if ( id ){
          this.meliServices.getProdutoCatalogoMLB(id,this.codeCompany).then(result=>{
              throw Error("Em implementação.");
          });
      }
  }

}
